<template>
  <div :class="`form-element form-${type}-element`">
    <FormLabel
      :required="options.required"
      :title="options.title"
      :filled="internalValue !== undefined && internalValue !== null"
      field-type="el.type"
    />
    <v-list>
      <draggable
        v-model="internalValue"
        handle=".handle"
      >
        <v-list-item
          v-for="(item, key) in internalValue"
          :key="key"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.label !== undefined ? item.label : item" />
          </v-list-item-content>

          <v-list-item-icon class="handle">
            <v-icon color="secondary">
              mdi-drag
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </draggable>
    </v-list>
  </div>
</template>

<script>
import FormLabel from '../FormLabel';
import draggable from 'vuedraggable';

export default {
  components: {
    FormLabel,
    draggable
  },
  props: {
    value: { type: Array, default: null },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  computed: {
    internalValue: {
      get () {
        return (this.value && this.value instanceof Array) ?
          this.value :
          this.options.elements.map((el) => el.value !== undefined ? el.value : el);
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>
